import React, { Component } from "react";
import Maintemplate from "./../mainTemplate/";
import BillDetail from "../../shared/bill/billDetail";

class BillProfile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Maintemplate>
      <BillDetail
        closeUrl={`/bills`}
        billId={this.props.match.params.billId} />
    </Maintemplate>
  }
}

export default BillProfile;
